export default {
  badge: 'Konfiguracja',
  title: 'Dokończ konfigurację restauracji',
  description: 'Pozostało kilka kroków, zanim restauracja będzie mogła działać na żywo.',
  count: '{{done}} z {{total}} kroków wykonanych',
  cta: 'Kontynuuj konfigurację',
  done: {
    badge: 'Wszystko gotowe',
    title: 'Wszystko gotowe',
    description: '{{partner}} uruchomi Twoją restaurację.',
    fallback_partner: 'Twój dostawca',
  },
};
